// src/pages/CreateBrandForm.jsx
import React, { useState } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import { createBrand } from "../api/brandApi";

const { Title } = Typography;

const CreateBrandForm = ({ onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await createBrand(values);
      message.success("¡Marca creada exitosamente!");
      onSuccess();
    } catch (error) {
      console.error("Error al crear la marca:", error);
      message.error("Error al crear la marca");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: 400,
        background: "#2a2a2a",
        color: "#ccc",
        padding: "1rem",
        borderRadius: "8px",
        border: "1px solid #444",
      }}
    >
      <Title level={3} style={{ color: "#fff" }}>
        Crear Marca
      </Title>
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          label={<span style={{ color: "#ccc" }}>Nombre de la Marca</span>}
          name="name"
          rules={[{ required: true, message: "Ingresa el nombre de la marca" }]}
        >
          <Input
            placeholder="Ej: NISSAN"
            style={{ background: "#1f1f1f", color: "#ccc" }}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{ marginRight: 8 }}
          >
            Crear Marca
          </Button>
          <Button onClick={onCancel}>Cancelar</Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateBrandForm;
